// src/pages/loan/loan_002_06.jsx
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "react-datepicker/dist/react-datepicker.css";

const Loan002_06 = () => {
    const [loanApplicationId, setloanApplicationId] = useState(null);

    useEffect(() => {
        // 쿼리 스트링에서 loanApplicationId 가져오기
        const params = new URLSearchParams(window.location.search);
        const id = params.get("loanApplicationId");
        setloanApplicationId(id);

        const handleMessage = (event) => {
          if (event.data === "CLOSE_SELF") {
              window.close();  // loan_002_06 창 닫기
          }
        };
        // 리스너 등록
        window.addEventListener("message", handleMessage);

        // cleanup (언마운트 시 제거)
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);


    if (!loanApplicationId) {
      return <div>Loading...</div>;
    }

    const url = `/loan/loan_002_standalone?loanApplicationId=${loanApplicationId}`;

    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          margin: 0,
        }}
      >
        <iframe
          src={url}
          title="Loan Detail"
          style={{ flexGrow: 1, border: "none", width: "100%" }}
        />
        <div
          style={{
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f1f1f1",
          }}
        >
          <button
            onClick={() => window.close()}
            style={{
              padding: "10px 20px",
              backgroundColor: "green",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
};

// // ReactDOM으로 바로 렌더링 (standalone 용)
// ReactDOM.render(
//   <React.StrictMode>
//     <Loan002_06 />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

export default Loan002_06;
